export default __webpack_public_path__ + "static/media/2236.fffa7285.png";